/* eslint-disable no-unused-vars */

export enum PageSpecificKeys {
    ReportPage = 'reportPage',
    DealsPage = 'dealsPage',
    DealPageBanners = 'dealPageBanners',
    DealsPageColumnOrder = 'dealsPageColumnOrder',
    DealsPageSorting = 'dealsPageSorting',
    DealDashboardPage = 'dealDashboardPage',
    ProFormaPage = 'proFormaPage',
    DocLibraryFilters = 'docLibraryFilters',
    DocLibraryRecentlyViewed = 'docLibraryRecentlyViewed',
    SignUpStage = 'signUpStage',
    SignUpData = 'signUpData',
    SignUpAuth0Data = 'signUpAuth0Data',
    IsDirectSignUpFlow = 'isDirectSignUpFlow',
    NewDealFormShowSuggestedOnly = 'newDealFormShowSuggestedOnly',
    SensitivityTables = 'sensitivityTables',
    ShowTargetReturns = 'showTargetReturns',
    ScenarioComparisonPage = 'scenarioComparisonPage',
}

export enum GlobalKeys {
    AppStateBeforeRedirection = 'appStateBeforeRedirection',
    ProFormaSideNavCollapsed = 'isProFormaSideNavCollapsed',
    ShowCents = 'showCents',
    ShowPartnerReturns = 'showPartnerReturns',
    SelectedScenarioId = 'userSelectedScenariosByProjectId',
    CookieConsent = 'cookieConsent',
}

export enum ConsentValue {
    Granted = 'granted',
    NotGranted = 'not-granted',
}
